export default {"src":"/_next/static/media/location-icon.8cca7d93.svg","height":17,"width":14,"blurWidth":0,"blurHeight":0};